import { httpClient } from './httpClient';

export const login = (payload) => httpClient.post('/auth/login', payload);
export const register = (payload) => httpClient.post('/auth/register', payload);
export const forgotPassword = (email) => httpClient.post('/auth/forgot-password', { email });
export const resetPassword = ({ token, newPassword }) => httpClient.post('/auth/reset-password', { token, newPassword });
export const me = () => httpClient.get('/auth/me');
export const logout = () => httpClient.post('/auth/logout');

const authService = { login, register, forgotPassword, resetPassword, me, logout };
export default authService;
